import { all, put, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import { StockPrice } from '../entities'
import { REACT_APP_GPWAPI_ENDPOINT, MS_AZURE_ENDPOINT } from '../../endpoints';

function* postFormsApi(url, target, action) {
  try {
    yield put({
      type: action.type + '_REQUEST',
      response: {
        customForms: {
          [target]: {
            status: null,
            message: null,
            validation: null,
            isFetching: true
          }
        }
      }
    })
    const result = yield new Promise((resolve, reject) => {
      const formData = new FormData()
      Object.keys(action).forEach(key => {
        // if (key === 'attachments')
        //   formData.append('attachments', action[key])
        if (key === 'attachments') {
          action[key].forEach((file, index) => {
            formData.append('attachments[' + index + ']', file)
          })
        }
        else {
          key !== "onSuccess" && formData.append(key, action[key])
        }
      })
//      axios.post(`${REACT_APP_FORMSAPI_ENDPOINT}${url}`,
      axios.post(`${MS_AZURE_ENDPOINT}`,
        formData,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data' //'application/json'
          },
          withCredentials: false
        }
      ).then(response => {
        action.onSuccess && action.onSuccess();
        resolve({
          status: 200,
          message: 'SUCCESS'
        })
      })
        .catch(error => {
          reject({
            status: 500,
            message: 'FAILURE'
          })
        })
    })
    yield put({
      type: action.type + '_SUCCESS',
      response: {
        customForms: {
          [target]: {
            status: result.status,
            message: result.message,
            validation: null,
            isFetching: false
          }
        }
      }
    })
  } catch (error) {
    yield put({
      type: action.type + '_FAILURE',
      response: {
        customForms: {
          [target]: {
            status: error.status,
            message: error.message,
            validation: null,
            isFetching: false
          }
        }
      }
    })
  }
}

function* submitContactWidget(action) {
  yield postFormsApi('/contactWidget', 'contactWidget', action)
}

function* resetContactWidget() {
  yield put({
    type: 'RESET_CONTACT_WIDGET_SUCCESS',
    response: {
      customForms: {
        contactWidget: null
      }
    }
  })
}

function* watchContactWidget() {
  yield takeEvery('SUBMIT_CONTACT_WIDGET', submitContactWidget)
  yield takeEvery('RESET_CONTACT_WIDGET', resetContactWidget)
}

function* submitCustomContactForm(action) {
  yield postFormsApi('/customContactForm', 'customContactForm', action)
}

function* resetCustomContactForm() {
  yield put({
    type: 'RESET_CUSTOM_CONTACT_FORM_SUCCESS',
    response: {
      customForms: {
        customContactForm: null
      }
    }
  })
}

function* watchCustomContactForm() {
  yield takeEvery('SUBMIT_CUSTOM_CONTACT_FORM', submitCustomContactForm)
  yield takeEvery('RESET_CUSTOM_CONTACT_FORM', resetCustomContactForm)
}

function* submitNewsletterWidget(action) {
  yield postFormsApi('/newsletterWidget', 'newsletterWidget', action)
}

function* resetNewsletterWidget() {
  yield put({
    type: 'RESET_NEWSLETTER_WIDGET_SUCCESS',
    response: {
      customForms: {
        newsletterWidget: null
      }
    }
  })
}

function* watchNewsletterWidget() {
  yield takeEvery('SUBMIT_NEWSLETTER_WIDGET', submitNewsletterWidget)
  yield takeEvery('RESET_NEWSLETTER_WIDGET', resetNewsletterWidget)
}

function* findStockPrices(action) {
  try {
    yield put({ type: 'FIND_STOCK_PRICES_REQUEST', target: action.target })
    const result = yield new Promise((resolve, reject) => {
      axios.get(REACT_APP_GPWAPI_ENDPOINT + '/stocks?page=' + action.page)
        .then(response => {
          resolve({
            stockPrices: response.data,
            prevPage: parseInt(response.headers['x-pager-prev'], 10),
            nextPage: parseInt(response.headers['x-pager-next'], 10),
            totalPages: parseInt(response.headers['x-pager-pages'], 10)
          })

        })
        .catch(error => {
          reject({
            code: error.response ? error.response.status : 404,
            msg: error.response ? error.response.data : 'Not Found'
          })
        })
    })

    const stockPricesEntities = {}
    const stockPricesList = []
    for (let i = result.stockPrices.length - 1; i >= 0; i--) {
      stockPricesList[i] = result.stockPrices[i].id
      stockPricesEntities[result.stockPrices[i].id] = new StockPrice(result.stockPrices[i])
    }

    yield put({
      type: 'FIND_STOCK_PRICES_SUCCESS',
      target: action.target,
      reset: true,
      response: {
        entities: {
          stockPrices: stockPricesEntities,//.map(stockPrice => new StockPrice({ stockPrice })),
        },
        ids: stockPricesList, //result.stockPrices.map(stockPrice => stockPrice.id),
        prevPage: result.prevPage,
        nextPage: result.nextPage,
        totalPages: result.totalPages,
        code: 200
      },
    })
  } catch (error) {
    yield put({
      type: 'FIND_STOCK_PRICES_FAILURE',
      target: action.target,
      response: {
        code: error.code
      }
    })
  }
}

function* watchFindStockPrices() {
  yield takeEvery('FIND_STOCK_PRICES', findStockPrices)
}

export const customSagas = [
  watchContactWidget(),
  watchCustomContactForm(),
  watchNewsletterWidget(),
  watchFindStockPrices()
]

export default function* rootSaga() {
  yield all([
    ...customSagas
  ])
}



// WEBPACK FOOTER //
// ./src/custom/sagas/index.js